<template>
	<div class="content">
		<router-view />
	</div>
</template>

<script>
	export default {
		components: {
		},
		created() {
			if(this.$store.state.authentication.user_role != 'super-admin') {
				this.$router.push("/");
			}
		},
		data() {
			return {
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Administrators.vue